import { MayerFabricsService } from 'src/app/services/mayer-fabrics.service';
import { Observable } from 'rxjs';
import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { Injectable } from '@angular/core';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { Acumatica } from '../acumatica-field-decorator';

@Injectable({
  providedIn: 'root'
})
export class WarehouseLocationInventoryInquiryService extends AcumaticaEntityService {
  constructor(
    acumatica: AcumaticaService,
    MayerFabrics: MayerFabricsService
  ) {
    super(acumatica, 'WarehouseLocationInventory', WarehouseLocationInventoryInquiry);
  }

  get(
    inquiry: WarehouseLocationInventoryInquiry,
    options: AcumaticaRequestOptions = {}
  ): Observable<WarehouseLocationInventoryInquiry> {
    return super.putEntity(inquiry, {
      ...options,
      ...{ expand: "Details" }
    });
  }
}

export class WarehouseLocationInventoryDetail extends AcumaticaEntity {
  @Acumatica() ItemClassID?: string;
  @Acumatica() InventoryID?: string;
  @Acumatica() Description?: string;
  @Acumatica() LotSerialHash?: string;
  @Acumatica() LotSerialNbr?: string;
  @Acumatica() LotSerialClass?: string;
  @Acumatica({ reader: parseFloat }) QtyOnHand?: number;
  @Acumatica({ reader: parseFloat }) QtyAvailable?: number;
  @Acumatica() BaseUnit?: string;
  @Acumatica() PatternClassID!: string | null;
  @Acumatica() PatternDescription!: string | null;
  @Acumatica({ reader: MayerFabricsService.LifeCycle }) LifeCycle!: string | null;
}

export class WarehouseLocationInventoryInquiry extends AcumaticaEntity {
  @Acumatica() WarehouseID!: string;
  @Acumatica() LocationID!: string;

  @Acumatica(WarehouseLocationInventoryDetail) Details!: WarehouseLocationInventoryDetail[];

  constructor(init?: Partial<WarehouseLocationInventoryInquiry>) {
    super();
    Object.assign(this, init);
  }

  /** group results of the inquiry
   * 
   * inquiry.Details = [
   *    InventoryID: string,
   *    ItemClassID: string,
   *    Description: string,
   *    QtyOnHand: <sum>
   *    QtyAvailable: <sum>
   *    Lots: [{
   *      LotSerialNbr: string,
   *      QtyOnHand: string,
   *      QtyAvailable: string
   *    },
   *    ...],
   *    ...
   * ]
  */
  groupResults(): WarehouseLocationInventoryInquiryGroup[] {
    if (!this.Details) return [];

    return this.Details.group<WarehouseLocationInventoryInquiryGroup>(
      {
        by: ['InventoryID', 'ItemClassID', 'Description'],
        sum: ['QtyOnHand', 'QtyAvailable']
      },
      'Lots',
      ['LotSerialNbr', 'LotSerialHash', 'QtyOnHand', 'QtyAvailable']);
  }
}

export interface WarehouseLocationInventoryInquiryGroup {
  InventoryID: string;
  ItemClassID: string;
  Description: string;
  QtyOnHand: number;
  QtyAvailable: number;
  Lots: WarehouseLocationInventoryInquiryDetail[];
}
export interface WarehouseLocationInventoryInquiryDetail {
  LotSerialHash: string;
  LotSerialNbr: string;
  QtyOnHand: number;
  QtyAvailable: number;
}